<template>
    <div class="col-lg-6 col-md-6 col-sm-12 col-12 connexion-right-aelp">
        <div class="connexion-right-in-aelp">
            <div class="loader" style="text-align:center" v-if="loader">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div v-else class="connexion-box-main-aelp">
                <div class="common-title-main-aehp common-title-center-aehp">
                    <h2>Déclarer un sinistre</h2>
                    <p>Munissez-vous de votre numéro de contrat afin d’accéder à la déclaration de sinistre</p>
                </div>
                <div class="connexion-form-aelp">
                    <div id='contractInput' class="conn-form-field1-aelp">
                        <div class="conn-form-field1-tit-aelp">Numéro de contrat</div>
                        <div class="conn-form-field1-tbox-aelp">
                            <input type="text" placeholder="" v-model="contract_number">
                        </div>
                        <div class="conn-form-error-message-aelp" v-if="invalidContract">
                            <span><i class="fa-solid fa-triangle-exclamation"></i>Veuillez renseigner une référence
                                valide</span>
                        </div>
                        <div class="conn-form-error-message-aelp" v-if="dailyLimitExceeded">
                            <span><i class="fa-solid fa-triangle-exclamation"></i>Notre plateforme de déclaration de
                                sinistre
                                est actuellement indisponible. Vous pouvez réessayer ultérieurement ou nous envoyer les
                                informations relatives à votre sinistre par lettre recommandée à l'adresse suivante :
                                AGEMI
                                11 rue Marguerite de Rochechouard
                                75009 Paris</span>
                        </div>
                    </div>
                    <div class="conn-form-submit-btn-aelp">
                        <button type="submit" v-on:click='find' class="btn default-btn-aehp">Se connecter</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import $ from 'jquery';
export default {
    name: 'CreateSinister',
    data() {
        return {
            contract_number: null,
            loader: false,
            dailyLimitExceeded: false,
            invalidContract: false
        }
    },
    methods: {
        ...mapActions('contract', ['findContract']),
        ...mapActions('createSinistre', ['reset']),
        find() {
            this.dailyLimitExceeded = false;
            this.invalidContract = false;
            $('#contractInput').removeClass('conn-form-error-aelp');
            if (this.contract_number) {
                this.loader = true;
                this.findContract(this.contract_number)
                    .then(() => {
                        this.loader = false;
                        this.reset();
                        this.$router.push('/assure/declaration')
                    })
                    .catch(async (error) => {
                        this.loader = false;
                        await this.$nextTick();
                        if (error.response.status === 429) {
                            this.dailyLimitExceeded = true;
                        } else {
                            this.invalidContract = true;
                        }
                        $('#contractInput').addClass('conn-form-error-aelp')
                    });
            }
          else{
                this.invalidContract = true;
                $('#contractInput').addClass('conn-form-error-aelp')
        }
      }
  }
  
}
</script>